module.exports = __webpack_public_path__ + "assets/404-bg-0.5x.f16498c3.webp";